import { render, staticRenderFns } from "./DeactiveForms.vue?vue&type=template&id=57b765fe"
import script from "./DeactiveForms.vue?vue&type=script&lang=js"
export * from "./DeactiveForms.vue?vue&type=script&lang=js"
import style0 from "./DeactiveForms.vue?vue&type=style&index=0&id=57b765fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports